import React from 'react'
import PropTypes from 'prop-types'

import TryFreeCta from '@/components/TryFreeCta'
import NeatVsCompetitorComparisonTable from '@/components/blocks/NeatVsCompetitorComparisonTable'
import FeatureComparison from '@/components/blocks/FeatureComparison'
import { Column, Layout, Row, Rows, Section } from '@/components/layout'
import BuyNowCta from '@/components/BuyNowCta'
import { Text, ButtonGroup } from '@/components/common'
import LogoTryFreeNav from '@/components/sections/LogoTryFreeNav'
import TestimonialSlider from '@/components/blocks/TestimonialSlider'
import InformationSecure from '@/components/blocks/InformationSecure'

import styles from './neatHomeVsCompetitor.module.scss'

export default function NeatVsCompetitorCompare({
  pageTitle,
  ctaTitle,
  competitorName,
  competitorLogo,
  heroTitle,
  overview = [],
  comparisons = [],
  featureComparison = [],
  testimonialSliderProps = {},
}) {
  return (
    <Layout.Content>
      <LogoTryFreeNav />
      <Section bgForeground paddingVertical={0} wrapperClassName={styles.wrapper}>
        <Column className="w-full">
          <div className={styles.heroHolder}>
            <div className="max-w-700">
              <Text.H1 brandSecondary normal size="medium">{pageTitle}</Text.H1>
              <Text bold className={styles.tagline} noMargin onTint size="large" type="display">{heroTitle}</Text>
              <Text.P onTint>Smart file organization designed to declutter, increase<br />
                efficiency, and gain peace of mind.
              </Text.P>
              <ButtonGroup className={styles.ctaButtons} marginTop={32}>
                <BuyNowCta style={{ border: '0' }} />
                <TryFreeCta />
              </ButtonGroup>
              <Text.P onTint size="xsmall">Neat is a yearly subscription where you can add on solutions.</Text.P>
            </div>
          </div>
        </Column>
      </Section>

      <Section paddingBottom={24}>
        <Rows gap={12} maxWidth={800}>
          <Row center textCenter>
            <Text.H2 className="c-brand" style={{ marginBottom: '30px' }}>Neat & {competitorName} Overview</Text.H2>
          </Row>

          {overview.length > 0 && (
            overview.map(paragraph => (
              <Row key={paragraph.title}>
                <div className={styles.overviewSection}>
                  <Text.H3 style={{ marginBottom: '30px' }}>{paragraph.title}</Text.H3>
                  {paragraph.text}
                </div>
              </Row>
            ))
          )}
        </Rows>
      </Section>

      <Section paddingBottom={24}>
        <Rows gap={12} maxWidth={800}>
          <Row center textCenter>
            <div>
              <Text.H2 className="c-brand" style={{ marginBottom: '30px' }}>Compare Neat vs {competitorName}</Text.H2>
              <Text.P center style={{ color: '#000000' }}>Neat is a smarter way to manage your receipts, documents, report expenses & much more. Smart file organization designed to declutter, increase efficiency, and gain peace of mind.</Text.P>
            </div>
          </Row>
        </Rows>
      </Section>

      <NeatVsCompetitorComparisonTable comparisons={comparisons} competitorLogo={competitorLogo} />

      <Section center textCenter>
        <Text.H2>{ctaTitle}</Text.H2>
        <ButtonGroup className={styles.ctaButtons}>
          <BuyNowCta style={{ border: '0' }} />
          <TryFreeCta />
        </ButtonGroup>
        <Text.P>Neat is a yearly subscription where you can add on solutions.</Text.P>
      </Section>

      <FeatureComparison
        competitorLogo={competitorLogo}
        featureComparison={featureComparison}
        title={`Feature Comparison between Neat vs ${competitorName}`}
      />

      <Section center textCenter>
        <Text.H2>{ctaTitle}</Text.H2>
        <ButtonGroup className={styles.ctaButtons}>
          <BuyNowCta style={{ border: '0' }} />
          <TryFreeCta />
        </ButtonGroup>
        <Text.P>Neat is a yearly subscription where you can add on solutions.</Text.P>
      </Section>

      <Section paddingTop={0}>
        <Rows gap={64}>
          <TestimonialSlider {...testimonialSliderProps} />
        </Rows>
      </Section>

      <InformationSecure />

      <Section center textCenter>
        <Text.H2>{ctaTitle}</Text.H2>
        <ButtonGroup className={styles.ctaButtons}>
          <BuyNowCta style={{ border: '0' }} />
          <TryFreeCta />
        </ButtonGroup>
        <Text.P>Neat is a yearly subscription where you can add on solutions.</Text.P>
      </Section>

    </Layout.Content>
  )
}

NeatVsCompetitorCompare.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  ctaTitle: PropTypes.string.isRequired,
  competitorName: PropTypes.string.isRequired,
  competitorLogo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  heroTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  overview: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  })),
  comparisons: PropTypes.arrayOf(PropTypes.shape({
    feature: PropTypes.string,
    neatText: PropTypes.string,
    competitorText: PropTypes.string,
  })),
  featureComparison: PropTypes.arrayOf(PropTypes.shape({
    rowTitle: PropTypes.string,
    neat: PropTypes.bool,
    competitor: PropTypes.bool,
  })),
  testimonialSliderProps: PropTypes.shape({}),
}
